export default __webpack_public_path__ + "static/Solcast-Case-Study-AWS-30e17c86505e62664a89755ca6c51397.pdf";